export default {
  // OSS 鉴权
  OSS_AUTH_API: '/me/sts',
  // 请求音频数据
  GET_AI_AUDIO_API: '/share/MusicAi',
};
